export enum LogicType {
  Dependency = 0,
  Classification = 1,
  Distribution = 2,
}
